import { zodResolver } from '@hookform/resolvers/zod';
import { agendaSlotTypeSchema, periodsOfTheDay } from '@omecare/utils';
import { z } from 'zod';

export const openOfficeAgendaSlotFormSchema = z.object({
  doctorAttendingId: z.string({ message: 'form.errors.required' }),
  slotType: agendaSlotTypeSchema,
  periodOfTheDay: z.enum(periodsOfTheDay),
  forceWithoutAssistant: z.boolean().default(false),
  specificDates: z.array(z.coerce.date()),
});

export type OpenOfficeAgendaSlotFormValues = z.infer<
  typeof openOfficeAgendaSlotFormSchema
>;

export const openOfficeAgendaSlotFormResolver = zodResolver(
  openOfficeAgendaSlotFormSchema,
);
